import "devextreme/dist/css/dx.common.css";
// import "../src/themes/generated/theme.base.css";
import "@sonphat/common-v1/assets/style/custom-themes.css";
import "@sonphat/common-v1/assets/style/custom-base.css";
import "@sonphat/common-v1/assets/style/custom.css";
import "@mdi/font/css/materialdesignicons.css";
// import "../src/assets/style/style.css";
import "@sonphat/common-v1/assets/style/style.css";
import "../src/assets/style/custom-project.css";